import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTFUNNELCHECKBOXITEMBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "checked",
  "required",
  "display_custom_title_in_comment",
  "custom_title"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartFunnelCheckboxItemBlockDescriptor: _generatedCartFunnelCheckboxItemBlockDescriptor,
  cartFunnelCheckboxItemBlockBlocDefinition,
  cartFunnelCheckboxItemBlockDashboardLayout,
  cartFunnelCheckboxItemBlockConfig,
  cartFunnelCheckboxItemBlockResolveConfig,
  cartFunnelCheckboxItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart funnel / Checkbox input",
    componentType: 'CartFunnelCheckboxItemBlockComponent',
    category: 'cart',
    description: "Cart funnel / Checkbox input.",
    keywords: [],
    allowedIn: [
      { bloc: "CartFunnelFormBlockComponent", slot: "items" },
    ],
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-checkbox-item.title.label",
        help: "pages.blocks.cart-funnel-checkbox-item.title.help",
      }
    }),
    checked: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.cart-funnel-checkbox-item.checked.label",
      }
    }),
    required: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.cart-funnel-checkbox-item.required.label",
      }
    }),
    display_custom_title_in_comment: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.cart-funnel-checkbox-item.display-custom-title-in-comment.label",
      }
    }),
    custom_title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-checkbox-item.custom-title.label",
        help: "pages.blocks.cart-funnel-checkbox-item.custom-title.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-funnel-checkbox-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-funnel-checkbox-item.fieldset.field.label",
            fields: ["title", "checked", "required"],
          },
          {
            legend: "pages.blocks.cart-funnel-checkbox-item.fieldset.order-comment.label",
            fields: [
              "display_custom_title_in_comment",
              {
                prop: "custom_title",
                visibleWhen: { display_custom_title_in_comment: true },
              },
            ],
          },
        ],
      },
    ],
  })
);

export function cartFunnelCheckboxItemBlockDescriptor(): IBlockDescriptor;
export function cartFunnelCheckboxItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartFunnelCheckboxItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartFunnelCheckboxItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartFunnelCheckboxItemBlockDescriptor, cartFunnelCheckboxItemBlockProperties, fieldOrder);
}

export {
  cartFunnelCheckboxItemBlockBlocDefinition,
  cartFunnelCheckboxItemBlockDashboardLayout,
  cartFunnelCheckboxItemBlockProperties,
  cartFunnelCheckboxItemBlockConfig,
  cartFunnelCheckboxItemBlockResolveConfig,
};

export type CartFunnelCheckboxItemBlockConfig = typeof cartFunnelCheckboxItemBlockConfig;
